import styled from 'styled-components';

export const TableContainer = styled.div`
  background-color: ${({ theme }) => theme.cardBackground || theme.white};
  border-radius: 8px;
  box-shadow: 0 2px 4px ${({ theme }) => theme.shadowColor || 'rgba(0, 0, 0, 0.1)'};
  overflow: auto;
  margin-bottom: 20px;
  max-height: 80vh;
  position: relative;
`;

export const Table = styled.table`
  width: 100%;
  border-collapse: collapse;
`;

export const TableHead = styled.thead`
  background-color: ${({ theme }) => theme.tableHeaderBackground || theme.lightGrayHover};
  position: sticky;
  top: 0;
  z-index: 10;
`;

export const TableHeader = styled.th`
  padding: 8px 12px;
  text-align: left;
  font-weight: 600;
  color: ${({ theme }) => theme.tableHeaderText || theme.darkColor};
  border-bottom: 2px solid ${({ theme }) => theme.borderColor};
  font-size: 0.9rem;
  background-color: ${({ theme }) => theme.tableHeaderBackground || theme.lightGrayHover};
  z-index: 10;
`;

export const TableRow = styled.tr<{ isSubRow?: boolean; active?: boolean; isSticky?: boolean }>`
  transition: background-color 0.2s;
  background-color: ${(props) => {
    if (props.active) return props.theme.expandedRowBackground || '#e6f7ff';
    if (props.isSubRow) return props.theme.subRowBackground || '#f5f5f5';
    return 'transparent';
  }};
  position: ${(props) => props.isSticky ? 'sticky' : 'relative'};
  z-index: ${(props) => props.isSticky ? '5' : '1'};

  &:hover {
    background-color: ${(props) => props.theme.tableHoverBackground || '#f0f0f0'};
  }
`;

export const TableCell = styled.td`
  padding: 8px 12px;
  border-bottom: 1px solid ${({ theme }) => theme.borderColor};
  font-size: 0.9rem;
  color: ${({ theme }) => theme.textColor};
`;

export const FilterInput = styled.input`
  width: 100%;
  padding: 4px 8px;
  border: 1px solid ${({ theme }) => theme.borderColor};
  border-radius: 4px;
  font-size: 0.85rem;
  background-color: ${({ theme }) => theme.inputBackground || theme.white};
  color: ${({ theme }) => theme.textColor};

  &:focus {
    outline: none;
    border-color: ${({ theme }) => theme.defaultColor};
    box-shadow: 0 0 0 2px ${({ theme }) => theme.defaultColorShadow};
  }
`;

export const FilterIcon = styled.span<{ active: boolean }>`
  cursor: pointer;
  margin-left: 4px;
  color: ${(props) => (props.active ? props.theme.defaultColor : props.theme.iconColor || '#666')};

  &:hover {
    color: ${({ theme }) => theme.defaultColor};
  }
`;

export const ExportIcon = styled.span`
  cursor: pointer;
  margin-left: 8px;
  color: ${({ theme }) => theme.primaryColor || '#38b000'};
  display: flex;
  align-items: center;
  font-size: 1.1rem;

  &:hover {
    color: ${({ theme }) => theme.primaryColorHover || '#008000'};
  }
`;

export const ActionContainer = styled.div`
  display: flex;
  gap: 8px;
`;

export const IconButton = styled.button`
  background: transparent;
  border: none;
  cursor: pointer;
  padding: 4px;
  color: ${({ theme }) => theme.iconColor || theme.darkColorLight};
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0.5rem;

  &:hover {
    color: ${({ theme }) => theme.textColor};
  }
`;

export const HeaderContent = styled.div`
  display: flex;
  align-items: center;
  gap: 4px;
`;

export const EmptyMessage = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 32px;
  color: ${({ theme }) => theme.textColor};
  font-size: 0.95rem;
  background-color: ${({ theme }) => theme.cardBackground || theme.white};
  border-radius: 8px;
  box-shadow: 0 2px 4px ${({ theme }) => theme.shadowColor || 'rgba(0, 0, 0, 0.1)'};
`;

export const LoadingContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 10px;
  padding: 15px 0;
  color: ${({ theme }) => theme.primaryColor || '#38b000'};
  font-size: 1.2rem;

  span {
    color: ${({ theme }) => theme.textColor};
  }
`;

export const ExpandButton = styled.button`
  background: none;
  border: none;
  cursor: pointer;
  color: ${(props) => props.theme.primaryColor || '#007bff'};
  display: flex;
  align-items: center;
  justify-content: center;
  width: 30px;
  height: 30px;
  border-radius: 50%;
  transition: background-color 0.2s;

  &:hover {
    background-color: ${({ theme }) => theme.expandButtonHoverBackground || 'rgba(0, 0, 0, 0.05)'};
  }
`;

export const ExpandedContent = styled.div`
  padding: 10px;
  padding-top: 0;
  background-color: ${({ theme }) => theme.expandedContentBackground || '#f9f9f9'};
  border-top: 1px solid ${({ theme }) => theme.borderColor || '#e0e0e0'};
  position: relative;
  z-index: 4;
  max-height: 300px;
  overflow-y: auto;

  p {
    color: ${({ theme }) => theme.textColor};
    text-align: center;
    padding: 15px;
    margin: 0;
  }
`;

export const SubTable = styled.table`
  width: 98%;
  border-collapse: collapse;
  margin-bottom: 5px;
  margin-left: 2rem;
  font-size: 0.9em;

  thead {
    position: sticky;
    top: -32px;
    background-color: ${({ theme }) => theme.subTableHeaderBackground || '#eaeaea'};
    z-index: 3;
  }

  th {
    background-color: ${({ theme }) => theme.subTableHeaderBackground || '#eaeaea'};
    padding: 8px;
    text-align: left;
    font-weight: 500;
    position: sticky;
    top: 0;
    z-index: 2;
    color: ${({ theme }) => theme.tableHeaderText || theme.darkColor};
  }

  td {
    padding: 6px 8px;
    border-bottom: 1px solid ${({ theme }) => theme.borderColor || '#eee'};
    color: ${({ theme }) => theme.textColor};
  }
`;
